var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailHasBeenConfirmed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 550,
    height: 399,
    viewBox: "0 0 550 399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a",
    x1: "3.779%",
    x2: "115.116%",
    y1: "122.034%",
    y2: "-52.558%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "36%",
    stopColor: "#00272E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "75%",
    stopColor: "#3F80A1",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#69B9EB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__b",
    x1: "60.712%",
    x2: "33.176%",
    y1: "21.262%",
    y2: "98.125%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91%",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__c",
    x1: "55.251%",
    x2: "29.015%",
    y1: "48.908%",
    y2: "54.364%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91%",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__d",
    x1: "57.641%",
    x2: "31.405%",
    y1: "48.411%",
    y2: "53.867%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91%",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__e",
    x1: "61.862%",
    x2: "29.364%",
    y1: "46.788%",
    y2: "55.216%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91%",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__f",
    x1: ".033%",
    x2: "100.048%",
    y1: "49.998%",
    y2: "49.998%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__g",
    x1: "51.816%",
    x2: "36.833%",
    y1: "1429.623%",
    y2: "1216.871%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__h",
    x1: ".741%",
    x2: "100.747%",
    y1: "691.414%",
    y2: "691.414%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__i",
    x1: ".554%",
    x2: "100.559%",
    y1: "619.33%",
    y2: "619.33%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__j",
    x1: "67.401%",
    x2: "21.082%",
    y1: "2283.353%",
    y2: "2510.736%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__k",
    x1: "58.711%",
    x2: "40.36%",
    y1: "71.893%",
    y2: "34.863%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__l",
    x1: "-25.592%",
    x2: "213.647%",
    y1: "105.122%",
    y2: "-51.896%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "42%",
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__m",
    x1: "42.645%",
    x2: "55.98%",
    y1: "40.484%",
    y2: "59.215%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C72BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#67DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#5CB3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#538EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#4C718B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#465A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#424A63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79%",
    stopColor: "#404059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3F3D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__n",
    x1: "37.533%",
    x2: "65.26%",
    y1: "-482.841%",
    y2: "-507.168%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4C72BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopColor: "#67DDF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "12%",
    stopColor: "#5CB3CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "24%",
    stopColor: "#538EA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "37%",
    stopColor: "#4C718B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#465A73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63%",
    stopColor: "#424A63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "79%",
    stopColor: "#404059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3F3D56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__o",
    x1: "34.455%",
    x2: "89.551%",
    y1: "-6.978%",
    y2: "193.427%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "91%",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C72BF",
    d: "M87.698 83.47c-16.258 3.445-33.156 7.185-46.208 17.475-11.02 8.681-28.193 24.708-33.397 37.73-22.042 55.005 2.88 121.938 51.251 156.168 22.75 16.1 51.104 23.894 71.55 42.845 12.93 11.987 21.988 27.854 35.747 38.872 20.105 16.087 47.25 19.646 72.939 21.37 17.847 1.208 36.389 1.729 52.947-5.056 11.97-4.902 22.108-13.309 32.06-21.596l65.933-55.046c10.593-8.834 20.498-22.905 34.291-22.811 124.143.888 132.512-145.177-58.017-209.872-16.791-5.702-28.307-21.556-44.083-29.683-32.589-16.794-70.093-11.352-102.962.267-41.733 14.792-88.742 20.128-132.051 29.336z",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000405",
    d: "M519.968 319.198c5.185.087 11.862 1.394 12.662 6.566.433 2.693-1.093 5.313-2.746 7.488-10.336 13.65-27.463 20.552-44.364 22.404-16.9 1.852-33.935-.741-50.809-2.842-24.386-3.044-48.867-5.064-73.44-6.06-17.474-.714-35.854-1.159-50.902-10.155-2.792-1.664-5.538-3.745-6.877-6.734-2.666-5.947 1.546-13.186 7.33-16.075 5.785-2.888 12.582-2.606 19.034-2.255 63.35 3.447 126.654 7.663 190.112 7.663z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C72BF",
    d: "M520.597 84.478s-22.605 29.272-26.895 34.177c-7.825 8.912-12.87 20.6-12.87 20.6l-11.359 48.402-12.696-3.392-27.604-7.36s9.81-26.456 5.059-34.485c-6.335-10.705-.856-17.396.588-21.992 2.673-8.518-10.979-24.087-10.979-24.087l-8.747-39.229 13.204-1.766 9.582 31.801 16.418 14.673 11.694.623s8.82 1.82 15.235-1.151c6.134-2.85 27.804-27.319 27.804-27.319l8.84 8.03 2.726 2.475zM411.635 133.38v174.29c0 4.41-1.75 8.64-4.862 11.757-3.112 3.117-7.331 4.865-11.73 4.865H135.06c-9.16 0-16.585-7.445-16.585-16.628V133.38c-.004-9.179 7.41-16.625 16.565-16.636h260.003c4.401 0 8.622 1.75 11.734 4.87 3.112 3.121 4.858 7.353 4.858 11.766z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C72BF",
    d: "M407.311 122.799H122.8l2.307-1.766c.107-.093.218-.18.334-.26L260.777 17.108l4.275-3.272 137.704 105.477 4.555 3.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C72BF",
    d: "M411.635 134.235l-3.462 2.506-25.212 18.296-122.403 88.83-117.719-90.835-24.364-18.797.313-3.23c.593-3.026 2.022-5.826 4.123-8.08.59-.644 1.233-1.237 1.922-1.772.106-.093.218-.18.333-.26 2.857-2.138 6.329-3.29 9.894-3.283h259.983c8.54.008 15.682 6.504 16.512 15.02.054.535.08 1.07.08 1.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M125.393 121.07c-.775.526-1.501 1.104-2.172 1.729h-.422l2.594-1.73z",
    opacity: 0.61
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M411.635 134.335l-3.462 2.511-25.212 18.272-122.403 88.75-117.719-90.746-24.364-18.787.313-3.219c.772-3.906 2.916-7.405 6.045-9.864l.333-.254L260.558 17.116l4.277-3.28 137.747 105.706c5.049 2.574 8.433 7.552 8.973 13.197.054.53.08 1.063.08 1.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M383.097 121.425v33.66l-45.224 32.74-10.373 7.536-66.945 48.507-62.964-48.507-9.758-7.51-45.144-34.743v-31.683c0-2.617 1.039-5.127 2.89-6.978 1.85-1.85 4.358-2.89 6.975-2.89h220.685c5.444.007 9.855 4.422 9.858 9.868z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M349.94 150.472H171.523c-.996 0-1.951-.41-2.656-1.14-.704-.73-1.1-1.72-1.1-2.752 0-1.032.396-2.022 1.1-2.752.705-.73 1.66-1.14 2.656-1.14H349.94c2.074 0 3.755 1.743 3.755 3.892 0 2.15-1.681 3.892-3.755 3.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M349.94 172.956H171.523c-.996 0-1.951-.41-2.656-1.14-.704-.73-1.1-1.72-1.1-2.752 0-1.032.396-2.021 1.1-2.751.705-.73 1.66-1.14 2.656-1.14H349.94c.996 0 1.95.41 2.655 1.14.704.73 1.1 1.72 1.1 2.751 0 2.15-1.681 3.892-3.755 3.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M338.129 187.657L327.786 195.44 198.246 195.44 188.522 187.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000405",
    d: "M260.907 243.003L152.201 324.292 371.855 324.292z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C72BF",
    d: "M166.855 60.535c-5.445-11.668-25.896-9.751-25.896-9.751 12.616-7.436 10.2-26.32 10.046-27.435 5.518 16.464 24.568 12.829 26.275 12.47-12.65 3.118-10.425 24.716-10.425 24.716zM131.689 84.748c-3.503-7.587-16.673-6.338-16.673-6.338 8.336-5.002 6.447-17.875 6.447-17.875v.074c3.577 10.648 15.813 8.286 16.902 8.056-8.108 2.036-6.676 16.083-6.676 16.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M481.617 62.328c1.58-1.275 3.58-1.91 5.603-1.776 1.481-.06 2.93.442 4.06 1.408.869.98 1.421 2.203 1.584 3.506.319 1.614.44 3.262.36 4.907-.144 3.019-.923 6.216.373 8.945.308.65.724 1.242 1.23 1.75.587.659 1.402 1.066 2.279 1.138.9.04 1.695-.585 1.872-1.473-.757 1.694-2.155 3.017-3.885 3.673-1.73.657-3.649.594-5.333-.174-.542-.25-1.053-.565-1.518-.94l1.139 2.321c-.944-.243-1.857-.592-2.724-1.04-2.782-1.519-4.34-4.603-5.08-7.721-.654-2.862-.785-5.815-1.4-8.69-.452-2.19-.334-4.242 1.44-5.834z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C72BF",
    d: "M480.758 64.867c.609-.02 1.215.068 1.79.26.97.38 1.635 1.24 1.725 2.228.055.997-.52 1.93-1.465 2.376-.603.232-1.252.339-1.902.312-.592 0-1.19 0-1.782-.053-.382.033-.73-.206-.817-.559-.386-.724-.677-1.49-.866-2.282-.487-2.448 1.26-2.302 3.317-2.282z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__f)",
    d: "M469.575 88.208s-.105 1.92-.237 4.418c-.112 2.107-.25 4.651-.362 6.764-.191 3.575-1.714 6.945-4.264 9.436-1.49 1.535-5.041 4.399-7.75 3.382-1.317-.492-1.363-2.166-1.087-3.17.611-1.828.951-3.738 1.009-5.667.043-1.562-.096-3.123-.416-4.652-1.693-4.272 13.107-10.511 13.107-10.511z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__g)",
    d: "M469.575 88.208s-.103 1.97-.232 4.536c-1.021 2.4-1.978 4.358-2.502 5.334-1.053 1.971-5.384 5.075-9.695 5.696.043-1.603-.094-3.206-.407-4.775-1.68-4.386 12.836-10.791 12.836-10.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__h)",
    d: "M456.967 63.14c-7.824.484-13.782 7.343-13.308 15.32 0 .344.052.674.099 1.024.441 5.884 1.922 11.638 4.372 16.984 4.623 8.081 16.34 1.434 18.196-1.892 1.856-3.327 8.976-18.331 5.984-22.58-2.06-2.87-7.774-9.166-15.343-8.856z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M452.378 55.466c5.076-1.45 10.491-1.296 15.473.443 4.903 1.822 9.132 5.573 11 10.374 1.605 4.45 1.452 9.326-.43 13.67-1.9 4.307-4.924 8.05-8.77 10.849-.99-2.972 2.065-5.613 3.252-8.512.276-.535.337-1.153.168-1.73-.431-1.077-2.077-1.195-3.015-.495-.937.7-1.349 1.882-1.693 2.984.91-4.721 1.585-10.268-1.828-13.728-2.023-2.047-5.078-2.813-7.992-2.84-5.41-.016-10.583 2.162-14.293 6.016-1.072 1.13-2.597 2.516-3.96 1.737-.423-.284-.755-.68-.957-1.143-4.027-7.805 6.55-15.881 13.045-17.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M459.096 64.066c-3.356-1.467-6.88-2.667-10.523-2.667-3.644 0-7.423 1.227-9.832 3.947-1.258 1.515-2.174 3.281-2.685 5.179-.403 1.188-.563 2.443-.47 3.693.146.906.37 1.798.672 2.666.63 2.16.899 4.666-.477 6.48-.517.731-1.343 1.188-2.242 1.24-.919.016-1.707-.65-1.838-1.554-.591 1.66.375 3.607 1.912 4.48 1.602.808 3.475.898 5.148.246.695-.216 1.34-.567 1.9-1.033.552-.528 1.006-1.148 1.341-1.833 1.403-2.526 2.108-5.333 3.155-8.059 1.047-2.726 2.563-5.333 5.04-6.866 1.962-1.065 4.167-1.609 6.402-1.58 2.222-.073 4.457.107 6.671-.093 2.215-.2.611-1.507-.342-2.193-1.203-.813-2.487-1.5-3.832-2.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__i)",
    d: "M548.973 39.963c.568.44-4.75 4.58-4.75 4.58s-2.486 4.279-5.012 5.467c-2.525 1.189-21.5 32.144-21.5 32.144l-7.49-6.782 16.155-21.717s5.345-10.234 4.75-14.686c0 0 .321-5.26 1.931-2.818 1.136 1.743.408 4.487 1.751 4.78.149.013.298-.02.428-.093 1.114-.675 2.136-1.492 3.04-2.43 2.672-2.544 5.866-6.082 5.866-6.082s1.75-.74 1.53 0c-.22.741-3.434 5.741-3.615 6.008.301-.273 5.232-4.673 6.014-4.332.782.34-3.822 5.407-4.09 5.7.288-.2 5.546-3.858 5.94-3.53.742.62-4.008 4.74-4.403 5.053.301-.16 2.914-1.689 3.455-1.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__j)",
    d: "M543.383 43.022c-.397.136-.818.172-1.23.105-1.342-.108-2.689-.131-4.033-.07-.905.042-2.775.7-2.821-.779 0-.392.093-.778.073-1.17-.01-.17-.031-.34-.067-.505 1.11-.71 2.128-1.567 3.028-2.553.408.144.793.35 1.144.61l2.622 1.788c.466.323.931.645 1.377.996.197.13.355.318.453.54.086.44-.146.88-.546 1.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__k)",
    d: "M412.642 4.98c-.74.081 1.655 6.428 1.655 6.428s-.15 4.972 1.368 7.32c1.519 2.35 1.368 38.347 1.368 38.347l10.18-1.341-2.313-27.115s.883-11.568 3.804-15.05c0 0 2.558-4.663-.158-3.429-1.929.886-2.784 3.61-4.104 3.154-.14-.064-.253-.173-.322-.309-.621-1.162-1.082-2.401-1.368-3.683-.964-3.59-1.813-8.3-1.813-8.3s-1.094-1.544-1.272-.799c-.178.745-.116 6.71-.11 7.052-.116-.382-2.052-6.77-2.907-6.884-.855-.114.404 6.643.486 7.032-.15-.322-2.736-6.227-3.27-6.16-.978.141.965 6.193 1.108 6.643-.191-.295-1.635-2.973-2.332-2.906z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__l)",
    d: "M415.296 10.88c.289.297.652.53 1.061.676 1.243.583 2.447 1.229 3.606 1.936.784.477 2.08 1.904 2.905.8.222-.286.326-.62.548-.912.101-.123.21-.242.326-.354-.63-1.075-1.097-2.22-1.387-3.406-.436-.091-.884-.125-1.331-.099l-3.252.056c-.584-.011-1.168.011-1.748.068-.246-.001-.488.064-.693.186-.302.293-.317.74-.035 1.049z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__m)",
    d: "M377.909 320.086c-2.66 5.372-4.594 9.547-4.594 9.547l-33.457 1.578s5.545-14.51 14.565-10.763c3.051 1.262 14.106-1.111 14.106-1.111l.346-1.098 9.034 1.847z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3D56",
    d: "M496.384 321.407l-5.14 2.885-44.006-46.336-4.854-61.857-40.124 36.459s1.073 25.105-12.955 44.746c-2.513 3.52-7.627 13.745-11.494 21.732-.12.248-.24.501-.354.748l-.753-.153-2.62-.548-5.688-1.175 18.442-74.667 41.905-66.826 27.543 7.347 12.668 3.386s8.548 17.157 0 61.563l-5.667 25.419s22.842 12.201 29.883 36.338l3.18 10.926.034.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__n)",
    d: "M496.407 321.698l5.165 5.39-13.115 13.635h-17.152s3.655-6.021 10.964-6.975c7.31-.955 9.058-9.214 9.058-9.214l5.08-2.836z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M143.886 49.194l-2.927.963c12.67-7.5 10.242-26.549 10.09-27.673.2.904 3.147 13.475 1.54 17.604-2.008 5.158-8.703 9.106-8.703 9.106zM123.227 72.255c-1.565 2.108-7.786 5.359-8.211 5.575 8.366-4.84 6.47-17.295 6.47-17.295v.072c.331.853 3.266 9.587 1.741 11.648zM119.832 143.206L255.463 248.192 261.164 243.918 119.34 134.041zM265.668 246.462L412.5 141.222 412.5 134.041 261.164 243.181z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M412.5 132.535l-.401 1.12-2.99 2.98c2.1-3.613-3.83-12.001-3.83-12.001l-2.368-1.767-7.107-5.334L261.164 17.11l4.286-3.274L403.507 119.36c5.057 2.572 8.448 7.54 8.993 13.175z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__o)",
    d: "M520.597 84.633s-22.666 29.228-26.968 34.125c-7.846 8.899-12.904 20.57-12.904 20.57l-11.39 48.33-12.731-3.388s11.886-44.314 16.663-53.72c4.777-9.407 44.583-48.396 44.583-48.396l2.747 2.479z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25233A",
    d: "M496.384 321.698c-.232-.667-7.701-21.587-18.914-30.359-11.386-8.912-18.002-21.213-18.002-21.213-2.646-23.615-2.864-85.928-2.864-85.928l12.57 3.382s8.48 17.138 0 61.492l-5.624 25.39s22.665 12.214 29.652 36.323l3.182 10.913zM402.628 253.03s1.073 25.054-12.956 44.657c-2.514 3.512-7.628 13.717-11.495 21.688l-1.107.594-2.62-.547 21.75-68.579s26.344-31.2 31.178-34.186c4.834-2.986 15.39 0 15.39 0l-40.14 36.373z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailHasBeenConfirmed);
export default __webpack_public_path__ + "static/media/email-has-been-confirmed.25049bc0eca1f960a7b94c00b74c6755.svg";
export { ForwardRef as ReactComponent };